export const UPDATE_SEARCH = "UPDATE_SEARCH";
export const UPDATE_ENTRIES = "UPDATE_ENTRIES";
export const PUSH_DETAILS = "PUSH_DETAILS";
export const POP_DETAILS = "POP_DETAILS";
export const CLEAR_DETAILS = "CLEAR_DETAILS";
export const CLEAR_ENTRIES = "CLEAR_ENTRIES";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const SET_SERVER_INSTANCE = "SET_SERVER_INSTANCE";
export const SET_DATA_SOURCE = "SET_DATA_SOURCE";
export const SET_CERTIFICATE_TYPE = "SET_CERTIFICATE_TYPE";
export const SET_CERTIFICATE_LABEL = "SET_CERTIFICATE_LABEL";
export const SET_LOGPAGE_NUM = "SET_LOGPAGE_NUM";
export const SET_RECENT_ENTRY = "SET_RECENT_ENTRY";
export const SET_SELECTED_AUTHORITY = "SET_SELECTED_AUTHORITY";
export const SET_REQUEST_MESSAGE = "SET_REQUEST_MESSAGE";
export const SET_PROCESSING_STATE = "SET_PROCESSING_STATE";